import React, { FC, useCallback } from 'react';
import { useRouter } from 'next/router';

// ========================= 组件 =========================
import Link from '../link';

// ========================= 数据交互 =========================

// ========================= 全局数据 =========================

// ========================= 常量 =========================

// ========================= 工具 =========================

// ========================= 样式 =========================

// ========================= 变量 =========================

// ========================= 类型 =========================

interface NavItem {
    key: string | number;
    name: string;
    href: string;
    isActive?: boolean;
    onClick?: (e?: React.MouseEvent<HTMLAnchorElement>) => void;
}

interface NavProps {
    items: NavItem[];
}

const Nav: FC<NavProps> = ({ items }) => {
    // nextjs获取当前页面的路径
    const router = useRouter();

    const isActive = useCallback((href: string) => {
        // 如果不是关于我们页面，就判断是否包含href
        if (href !== '/about') {
            return router.asPath.includes(href);
        } else {
            // 如果是关于我们页面，就判断是否完全相等
            return router.asPath === href;
        }
    }, [router.asPath]);

    return (
        <nav className="__nav">
            <ul>
                {
                    items.map((item) => {
                        const active = isActive(item.href);
                        return (
                            <li key={item.key} className={`${active || item.isActive ? 'active' : ''}`}>
                                <Link className="link" href={!active || !item.isActive ? item.href : '#'} onClick={item.onClick}>
                                    {item.name}
                                </Link>
                            </li>
                        )
                    })
                }
            </ul>
        </nav>
    );
}
export default Nav;